/** Waveform peaks media → channel arrays for wavesurfer. Accepts number[], {peaks: number[] | number[][]} and
 * audiowaveform JSON {data: [min,max,…], bits, channels}. Returns null when the shape is unknown. */
export function parsePeaks(raw: unknown): number[][] | null {
  const isNums = (x: unknown): x is number[] => Array.isArray(x) && x.every((v) => typeof v === "number");
  if (isNums(raw)) return [raw];
  if (raw && typeof raw === "object") {
    const o = raw as Record<string, unknown>;
    if (isNums(o.peaks)) return [o.peaks];
    if (Array.isArray(o.peaks) && o.peaks.length > 0 && o.peaks.every(isNums)) return o.peaks as number[][];
    if (isNums(o.data)) {
      const bits = typeof o.bits === "number" ? o.bits : 8;
      const scale = 2 ** (bits - 1);
      const channels = typeof o.channels === "number" && o.channels > 0 ? o.channels : 1;
      const stride = 2 * channels;
      const out: number[] = [];
      for (let i = 0; i + 1 < o.data.length; i += stride) {
        const lo = Math.abs(o.data[i] as number);
        const hi = Math.abs(o.data[i + 1] as number);
        out.push(Math.max(lo, hi) / scale);
      }
      return [out];
    }
  }
  return null;
}
